import GetDocumentByIdRequestModelBase from '../_generated/modelBases/get-document-by-id-request-model-base';

export default class GetDocumentByIdRequestModel extends GetDocumentByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
